import groupBy from 'lodash/groupBy'

export const getDocumentId = (doc) => doc?._id || doc

export const getDocumentKey = (doc) => doc?.key || doc

export const getDocumentIdAsString = (doc) => getDocumentId(doc)?.toString?.()

export const getDocumentKeyAsString = (doc) => getDocumentKey(doc)?.toString?.()

export const isSameDocument = (doc1, doc2) => {
    if (!doc1 || !doc2) return false
    return getDocumentIdAsString(doc1) === getDocumentIdAsString(doc2)
}

export const isSameKey = (doc1, doc2) => {
    if (!doc1 || !doc2) return false
    return getDocumentKeyAsString(doc1) === getDocumentKeyAsString(doc2)
}

export const convertToUrlParams = (query) =>
    query ? `?${new URLSearchParams(query).toString()}` : ''

export const objectToURLParams = (obj) => {
    const params = new URLSearchParams()
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (obj[key]) params.append(key, obj[key])
        }
    }
    return params.toString()
}

export const groupByField = (items, field) => groupBy(items, field)

export const groupByFieldFunc = (items, func) => groupBy(items, func)

export const mod = (value, period) => {
    const result = value % period
    return result < 0 ? result + period : result
}
